import clsx from 'clsx'
import React from 'react'
import { useSelector } from 'react-redux'
import ProcessorModal from '.'

export default function CompletedModal({ open = false, onClose = () => {}, onCancel = () => {}, onSubmit = () => {} }) {
  const {
    requesterInfo: { name },
    autoArchive,
  } = useSelector((state) => state.global)

  return (
    <ProcessorModal open={open} onClose={onClose}>
      <div className="dome-bg-white" style={{ padding: '36px 60px 24px 60px', borderRadius: 6 }}>
        <div className="dome-d-flex dome-flex-column dome-gap24">
          <div className="dome-d-flex dome-justify-center dome-align-end dome-gap12">
            <span className="dome-d-flex dome-align-center ">
              <i style={{ fontSize: '42px' }} className="fa-thin fa-circle-check dome-color-dark-green"></i>
            </span>
            <span className="dome-h2 dome-color-dark-green">we're on it!</span>
          </div>
          <div style={{ width: 380 }}>
            <p className="dome-p2 dome-color-darkest-grey">
              This Questionnaire is being packaged and will be sent to {name} when it’s ready.
            </p>
            <p style={{ marginTop: 30 }} className="dome-p2 dome-color-darkest-grey">
              Feel free to leave this page—no further action is needed on your part.
            </p>
          </div>
          <div className={clsx('dome-d-flex', autoArchive ? 'dome-justify-center' : 'dome-justify-between')}>
            <button
              type="button"
              onClick={onCancel}
              className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-cancel"
            >
              back to dashboard
            </button>
            {!autoArchive && (
              <button type="button" onClick={onSubmit} className="dome-btn dome-btn-base dome-btn-grey-stroke">
                archive questionnaire
              </button>
            )}
          </div>
        </div>
      </div>
    </ProcessorModal>
  )
}
